var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartUnLikeIconHovered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6539 2.35424L17.6547 2.35504C19.7161 4.46968 19.713 7.75901 17.658 9.85736L17.6579 9.85748L10.0002 17.6799L2.3426 9.85748L2.34248 9.85736C0.28713 7.75867 0.284781 4.46933 2.34178 2.35914L2.34294 2.35795C2.82265 1.86379 3.39235 1.47237 4.01881 1.20533C4.64508 0.938379 5.31622 0.800782 5.99377 0.8C7.27212 0.800148 8.50677 1.29061 9.45254 2.17896L10.0002 2.69336L10.5479 2.17904C11.4938 1.29077 12.7285 0.800309 14.0069 0.8C14.6836 0.800581 15.3539 0.937745 15.9795 1.20407C16.6053 1.47045 17.1745 1.86104 17.6539 2.35424Z",
    stroke: "url(#paint0_linear_1966_9970)",
    strokeWidth: 1.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1966_9970",
    x1: 0,
    y1: 9.41177,
    x2: 20,
    y2: 9.41177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06BCC1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartUnLikeIconHovered);
export default __webpack_public_path__ + "static/media/HeartUnLikeIconHovered.30eda8e4fb86bf19762ac8dd7ab37ab0.svg";
export { ForwardRef as ReactComponent };